<div class="content">
    <div class="containter">
        <div class="table-container mat-elevation-z3">

            <table mat-table [dataSource]="items" matSort matSortDisableClear [matSortDirection]="sortDirection"
                [matSortActive]="sortColumn" (matSortChange)="onSortData($event)">

                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.users.last-name' |
                        translate}}
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                </ng-container>

                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.users.first-name' |
                        translate}}
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
                </ng-container>

                <ng-container matColumnDef="userName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'administration.users.user-name' |
                        translate}}
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
                </ng-container>

                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef> {{'administration.users.role' | translate}} </th>
                    <td mat-cell *matCellDef="let element"> <span
                            *ngFor="let role of element.roles; index as idx">{{'administration.users.roles.'+
                            roleEnum[role]
                            | lowercase | translate}}{{element.roles.length > 1 && idx !=
                            element.roles.length - 1 ? ', ' : ''}}</span></td>
                </ng-container>

                <ng-container matColumnDef="isActive">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.active' | translate}} </th>
                    <td mat-cell *matCellDef="let element">
                        <div *ngIf="element.isActive; then thenBlock else elseBlock"></div>
                        <ng-template #thenBlock>
                            <span class="icon-active">
                                <fa-icon [icon]="faCheck" size="lg"></fa-icon>
                            </span>
                        </ng-template>
                        <ng-template #elseBlock>
                            <span class="icon-inactive">
                                <fa-icon [icon]="faTimes" size="lg"></fa-icon>
                            </span>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> {{'common.actions' | translate}} </th>
                    <td mat-cell *matCellDef="let element;">
                        <button mat-mini-fab color="primary" matTooltip="{{'administration.users.edit' | translate}}"
                            aria-label="Edit user" (click)="addOrEditUserOpenDialog(element.id)">
                            <fa-icon [icon]="faUserEdit"></fa-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container *ngFor="let column of columns" [matColumnDef]="column.filter.name">
                    <th mat-header-cell *matHeaderCellDef="let element">
                        <app-table-filter [column]="column" [filter]="filter"
                            (filterChange)="filterData($event)"></app-table-filter>
                    </th>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="filters"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            </table>

            <div class="empty-results" *ngIf="items.length === 0">{{'common.empty-results' | translate}}
            </div>

            <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex" color="primary"
                [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event)"
                showFirstLastButtons class="mat-paginator-row">
            </mat-paginator>
        </div>
    </div>
</div>